import React from "react";
/* import "@styles/sass/5-pages/sponsor.scss";
import "@styles/sass/2-components/_form.scss"; */

const SponsorForm = () => {
  return (
    <form >
      <div className="row">
        <div className="col-lg-6">
          <div className="form-group">
            <input type="text"   placeholder={t("Your Name")} />
            <i className="fa fa-user"></i>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <input type="text" placeholder="Company Name" />
            <i className="fa fa-info"></i>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <input type="email"  placeholder={t("Your Email")} />
            <i className="fa fa-envelope"></i>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <input type="text" placeholder="Your Phone" />
            <i className="fa fa-phone"></i>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <input type="text" placeholder="Address Line-1" />
            <i className="fa fa-map-marker-alt"></i>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <input type="text" placeholder="Address Line-2" />
            <i className="fa fa-map-marker-alt"></i>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-group">
            <textarea placeholder="Describe Your Message"></textarea>
            <i className="fa fa-pen-nib"></i>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-btn">
            <button type="submit" className="btn btn-inline">
              <i className="fas fa-paper-plane"></i>
              <span>send your proposal</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SponsorForm;
